export default {
  pages: {
    knowledgeBaseShow: {
      title: 'Video material',
      goBack: 'Orqaga',
    },
  },
};
